import { ExtendedBoardDto } from "./DirectorBoardSearchModal"
import { extractDateFromDateInt } from "../DirectorInformationSection";
import { Button, Colors, Display } from "Views/Components/Button/Button";
import { ButtonGroup } from "Views/Components/Button/ButtonGroup";

type Props = {
	board: ExtendedBoardDto;
	isCurrent: boolean;
}

export const BoardAsPotentialNewCustomer: React.FunctionComponent<Props> = ({
	board,
	isCurrent
}) => {
	return (
		<div className="director-board-potential-customer-section">
			<div className="info">
				<div className="info-item">
					<p className="name"><strong>Organisation Name:</strong> {board.organisationName}</p>
					<p className="type"><strong>{board.searchType}:</strong> {board.searchTerm}</p>
					<p className="status"><strong>Company Status: </strong> {board.companyStatus}</p>
					{!isCurrent && (
						<>
							<p className="date-deregistered" ><strong>Date Deregisted:</strong> {extractDateFromDateInt(board.deregisteredDate) === "-" ? "N/A" : extractDateFromDateInt(board.deregisteredDate)}</p>
							<p className="reason-deregistered"><strong>Reason Deregistered: </strong>{(board.reasonDeregistered ? board.reasonDeregistered : "N/A")}</p>
						</>
					)}
				</div>
				<div className="alert alert__warning" style={{ textAlign: "center"}}>
					<p>No records found for this entity within your Monitor database.</p>
				</div>
			</div>
			<ButtonGroup className="action">
				<Button
					display={Display.Outline}
					colors={Colors.Primary}
					onClick={() => {
						window.open(`/hub/credit-reports/generate?lookupMethod=${board.searchType}&lookupValue=${board.searchTerm}&countryCode=AU&stage=provider`, "_blank")
					}}
				>
					Generate Credit Report
				</Button>
				<Button
					display={Display.Outline}
					colors={Colors.Primary}
					onClick={() => {
						window.open(`/monitor/customers/add?${board.searchType}=${board.searchTerm}`, "_blank")
					}}
				>
					Monitor Customer
				</Button>
			</ButtonGroup>
		</div>
	)
}